import { createSlice } from "@reduxjs/toolkit";

const uiSlice = createSlice({
  name: "ui",
  initialState: {
    isRed: false
  },
  reducers: {
    setIsRed: (state, action) => {
      state.isRed = action.payload;
    }
  }
});

export const { setIsRed } = uiSlice.actions;
export default uiSlice.reducer;
